import { selectStatus } from 'services/store/utils-selectors';
import { statusTypes } from '../definitions';

const selectScheduleStatus = (state, action, ...parameters) => (
  selectStatus(state, 'schedules', statusTypes[action] || action, parameters) || {}
);

export default selectScheduleStatus;
